import React from 'react';
import ReactDOM from 'react-dom/client';  // Correct import
import App from './app.jsx';

const root = document.getElementById('root');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



